export default {
    ROTINA: 1,
    ESPECIAL: 2,
    BLOQUEIO: 3,
    INTENSIFICACAO: 4,
    CAMPANHA_INDISCRIMINADA: 5,
    CAMPANHA_SELETIVA: 6,
    SOROTERAPIA: 7,
    SERVICO_PRIVADO: 8,
    MONITORAMENTO: 9,
    PESQUISA: 10,
    PRE_EXPOSICAO: 16,
    POS_EXPOSICAO: 17,
    REEXPOSICAO: 18
}